import { ChannelCommunicationToSendDto } from "@hd/types/dto/communication/communication-to-send.dto";
import { ConversationChannelType } from "@hd/types/dto/shared/enums/conversation-channel-type";

export interface SendDrafts {
  emailBody: string;
  emailRecipients: string[];
  whatsappPhoneNumber: string | null;
}

const nonEmpty = (recipients: string[]): string[] | null => {
  const filled = recipients.filter((recipient) => recipient.trim() !== "");
  // niente destinatari = null, risolve il BE.
  return filled.length > 0 ? filled : null;
};

/**
 * Invia disabilitato: nessun canale scelto, invio in corso, oppure email
 * scelta ma corpo non ancora caricato (manderebbe una mail vuota).
 */
export function isSendDisabled(
  selectedChannelIds: ConversationChannelType[],
  isSending: boolean,
  hasEmailBody: boolean,
): boolean {
  if (isSending) return true;
  if (selectedChannelIds.length === 0) return true;

  return (
    selectedChannelIds.includes(ConversationChannelType.Email) && !hasEmailBody
  );
}

/**
 * Una voce per ogni canale selezionato, nell'ordine in cui arrivano.
 * Il timestamp lo passa il chiamante
 * Il subject non lo mandiamo: il default lo mette l'api (prima si passava null).
 */
export function buildChannelCommunicationsToSend(
  selectedChannelIds: ConversationChannelType[],
  drafts: SendDrafts,
  dateTime: string,
): ChannelCommunicationToSendDto[] {
  return selectedChannelIds.map((channelId) => {
    if (channelId === ConversationChannelType.Email) {
      return {
        channelId,
        dateTime,
        recipients: nonEmpty(drafts.emailRecipients),
        content: drafts.emailBody,
      };
    }

    if (channelId === ConversationChannelType.WhatsApp) {
      return {
        channelId,
        dateTime,
        recipients: drafts.whatsappPhoneNumber
          ? [drafts.whatsappPhoneNumber]
          : null,
        content: "",
      };
    }

    // canale non gestito: lo inoltriamo comunque, dati al BE
    return {
      channelId,
      dateTime,
      recipients: null,
      content: "",
    };
  });
}
